export const qualities = [
  "Commitment",
  "Responsibility",
  "Constancy",
  "Autodidact",
  "Teamwork",
];
